import { render, staticRenderFns } from "./alterar-senha.vue?vue&type=template&id=d0ebe4d4&"
import script from "./alterar-senha.vue?vue&type=script&lang=js&"
export * from "./alterar-senha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports